import { handleApiError } from '@api';
import config from '@config';
import { HTTPClient } from '@platform2-lib/httpz';
import * as schema from '@schema';
import type { AgentVersionsResponse, Dataset, PromptUsage } from 'types/schema';

const client = new HTTPClient(
  config.env,
  `${config.api.origin}/spark-agent-v2`
);

async function getAgentVersions(): Promise<AgentVersionsResponse> {
  try {
    const query = new URLSearchParams();
    query.set('agent', config.chat.sseAgent);

    const response = await client.get(
      `/agents/versions?${query.toString()}`,
      schema.AgentVersionsResponse
    );

    return response;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve agent versions.');
  }
}

async function getAccessibleDatasets(): Promise<Dataset[]> {
  try {
    const { datasets } = await client.get(
      '/datasets',
      schema.DatasetAccessResponse
    );

    return datasets;
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve dataset access.');

    return [];
  }
}

async function getPromptUsage(): Promise<PromptUsage> {
  try {
    return await client.get('/chat/usage', schema.PromptUsage);
  } catch (error: unknown) {
    handleApiError(error, 'Failed to retrieve the current quota.');

    return { ['usage_remaining']: -1 };
  }
}

export const user = {
  getAgentVersions,
  getAccessibleDatasets,
  getPromptUsage
};
